import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import Hero from "@/pages/home/components/Hero";
import StatsStrip from "@/pages/home/components/StatsStrip";
import FeaturedEvents from "@/pages/home/components/FeaturedEvents";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import ProcessSection from "@/pages/home/components/ProcessSection";
import LatestReview from "@/pages/home/components/LatestReview";
import TestimonialSection from "@/pages/home/components/TestimonialSection";
import FaqSection from "@/pages/home/components/FaqSection";
import SubscribeSection from "@/pages/home/components/SubscribeSection";
import { siteInfo } from "@/mocks/site";

export default function Home() {
  useDocumentMeta({
    title: "网红事件完整经过与深度解析｜前因后果一次说清 - 吃瓜复盘局",
    description:
      "吃瓜复盘局专注网红事件完整经过梳理，从起因到发酵全程复盘，深度解析各方关键信息与争议焦点，帮你快速看懂事件前因后果，一篇理清来龙去脉。",
    keywords: "网红事件,网红事件完整经过,网红事件深度解析,网红事件前因后果,网红事件全程复盘",
    canonical: `${siteInfo.domain}/`,
    type: "website",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: siteInfo.name,
        url: `${siteInfo.domain}/`,
        description: siteInfo.shortDesc,
        email: siteInfo.email,
      },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: siteInfo.name,
        url: `${siteInfo.domain}/`,
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: `${siteInfo.domain}/events?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "网红事件完整经过与深度解析",
        url: `${siteInfo.domain}/`,
        description: siteInfo.shortDesc,
        isPartOf: { "@type": "WebSite", url: `${siteInfo.domain}/` },
      },
    ],
  });

  return (
    <>
      <Hero />
      <StatsStrip />
      <FeaturedEvents />
      <CategoryGrid />
      <ProcessSection />
      <LatestReview />
      <TestimonialSection />
      <FaqSection />
      <SubscribeSection />
    </>
  );
}